<app-hometwo-banner></app-hometwo-banner>

<app-hometwo-boxes></app-hometwo-boxes>

<app-hometwo-about></app-hometwo-about>

<app-hometwo-mission></app-hometwo-mission>

<app-hometwo-funfacts></app-hometwo-funfacts>

<app-hometwo-services></app-hometwo-services>

<app-hometwo-process></app-hometwo-process>

<app-hometwo-scientist></app-hometwo-scientist>
    
<app-hometwo-testimonials></app-hometwo-testimonials>

<app-hometwo-partner></app-hometwo-partner>

<app-project-start></app-project-start>

<app-homeone-blog></app-homeone-blog>